






































































































































































































































































































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'relatedFactsList'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      fact_id: { required },
      water: { },
      water_temp: { },
      ferment_temp: { },
      heat_to: { },
      delay: { },
      homogen_time: { },
      pressure: { },
      quantity: { },
      weight: { },
      start_time: { },
      ferment_time: { },
      homoget_time: { },
      inertia: { },
      frozen_time: { },
      acidity: { },
      acidity_fact: { },
      how_shift: { },
      diff_causticity: { },
      pressure_diff: { },
      pressure_healt: { },
      pressure_cold: { },
      corrector_id: { },
      corrector_added_at: { },
      corrector_quantity: { },
      starter_type_id: { },
      starter_type_added_at: { },
      starter_type_quantity: { },
      regulator_id: { },
      regulator_added_at: { },
      regulator_quantity: { },
      caucity_avg: { },
    }

    return {
      form: rules
    }
  }
})
export default class ShiftVDPJournalForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;

  document!: any
  form!: any
  relatedFactsList!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  onFactChange($event: any) {
    console.log($event);
    if ($event && $event.label) {
      this.changeValue('quantity', $event.quantity);
      this.changeValue('weight', $event.weight_neto);
    }
  }

  prefilterShiftFact(item: any, index: number) {
    const existsList = this.relatedFactsList.map((item: any) => {
      return item.shift_plan_id
    })
    return !existsList.includes(item.id)
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

